/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Credit_BlockedInputs */

const en_queue_sos_credit_blocked = /** @type {(inputs: Queue_Sos_Credit_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders stopped for credit`)
};

/**
* | output |
* | --- |
* | "Sales orders stopped for credit" |
*
* @param {Queue_Sos_Credit_BlockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_credit_blocked = /** @type {((inputs?: Queue_Sos_Credit_BlockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Credit_BlockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_credit_blocked(inputs)
});